<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

<h4>卦例</h4>

這是您研究、管理卦例的地方，大概也是您會最常到訪的地方。您可以：

- 複習卦例：無論您占什麼，隨著事情的發展、或是事過境遷之後，回來複習卦例，也許會給您更多的靈感與理解。
- 移除卦例：請注意，卦例一旦移除，就沒有了。請小心使用。
- 解卦：您可以隨時解卦、隨時更改、編輯。
- 做筆記：每一條筆記，都是獨立的內容，一旦存入，就不能更動，因為這是反映出您在某一個時間點、對這一卦的理解，對或不對都沒關係，您也可以用它來紀錄某個相關的參考資料。這是用來紀錄您隨著時間的變化對一個卦裡的理解，您可以從這個過程，試著找到您的盲點與誤解。當您覺得到一個階段，就可以回去更新您的解卦。

{:else }

<h4>卦例</h4>

这是您研究、管理卦例的地方，大概也是您会最常到访的地方。您可以：

- 复习卦例：无论您占什么，随著事情的发展、或是事过境迁之后，回来复习卦例，也许会给您更多的灵感与理解。
- 移除卦例：请注意，卦例一旦移除，就没有了。请小心使用。
- 解卦：您可以随时解卦、随时更改、编辑。
- 做笔记：每一条笔记，都是独立的内容，一旦存入，就不能更动，因为这是反映出您在某一个时间点、对这一卦的理解，对或不对都没关系，您也可以用它来纪录某个相关的参考资料。这是用来纪录您随著时间的变化对一个卦里的理解，您可以从这个过程，试著找到您的盲点与误解。当您觉得到一个阶段，就可以回去更新您的解卦。

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  
</style>
